import { render } from "./MiniChat.vue?vue&type=template&id=10cd3d38&scoped=true"
import script from "./MiniChat.vue?vue&type=script&lang=js"
export * from "./MiniChat.vue?vue&type=script&lang=js"

import "./MiniChat.vue?vue&type=style&index=0&id=10cd3d38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cd3d38"]])

export default __exports__